import type { ApiResult } from '@/core/either';
import type { RemunerationClpDrawerData } from '../types/remunerationClp.type';
import { http } from '@/core/api';
import { executeRequest } from '@/core/either';

/**
 * Servicio para gestionar la remuneración CLP
 */
export const remunerationClpService = {
  /**
   * Obtiene los datos de remuneración CLP desde la API
   * @param {number} walletId - ID de la cuenta (walletId) requerido como header
   * @returns {Promise<ApiResult<RemunerationClpDrawerData>>} Promesa con el resultado tipado usando Either
   */
  getRemunerationClpData(walletId: string): Promise<ApiResult<boolean>> {
    return executeRequest(() =>
      http.get<RemunerationClpDrawerData>(`product-gateway/b2b/account/${walletId}/remuneration-status`)
    );
  },

  /**
   * Activa la remuneración CLP
   * @param {number} walletId - ID de la cuenta (walletId) requerido como header
   * @returns {Promise<ApiResult<void>>} Promesa con el resultado tipado usando Either
   */
  activateRemunerationClp(walletId: string): Promise<ApiResult<void>> {
    return executeRequest(() =>
      http.post<void>(`product-gateway/b2b/account/${walletId}/remunerated-account`),
    );
  },

};